import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OrganisationService } from '../organisation.service';
import { map, take } from 'rxjs/operators';
import { IRole, Organisation } from '../organisation.types';
import { UserService } from 'app/core/user/user.service';
import { combineLatest, forkJoin } from 'rxjs';
import { User } from 'app/core/user/user.types';

export const organisationNotOnBoardedGuard: CanActivateFn = (route, state) => {
    const _organisationService = inject(OrganisationService);
    const _router = inject(Router);
    const _userService = inject(UserService);

    // Only allow if NOT onboarded, else redirect to dashboard (or wherever you want)
    // get user role 
    const userRole = _userService.userRole$.pipe(take(1));
    const user = _userService.user$.pipe(take(1));
    const currentOrgaisation = _organisationService.currentOrganisation$;
    const isCreatingANewOrganisation = _router.url.includes('create-organisation');
    return combineLatest([userRole, user, currentOrgaisation]).pipe(
        take(1),
        map(([userRole, user, currentOrgaisation]: [IRole, User, Organisation]) => {
            if (userRole.name.toLowerCase() === 'member' && !isCreatingANewOrganisation) {
                if (!user.userPreferences) {
                    return true;
                }
            }
            if (currentOrgaisation?.onboarded) {
                // Redirect to dashboard or home if already onboarded
                return _router.createUrlTree(['/' + currentOrgaisation.slug + '/dashboard']);
            }
            return true;
        })
    );
}; 